import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const organisationsPlugin = createPlugin({
  id: 'organisations',
  routes: {
    root: rootRouteRef,
  },
});



export const OrganisationsPage = organisationsPlugin.provide(
  createRoutableExtension({
    name: 'OrganisationsPage',
    component: () =>
      import('./components/IndexPage').then(m => m.IndexPage),
    mountPoint: rootRouteRef,
  }),
);
